module.exports = __webpack_public_path__ + "images/application/postman-logo-e43c2a87.svg";